export default "__VITE_ASSET__H$_mwawHOdlRDU3dkqZAFw__"